import { ComboboxAdditional } from './ComboboxAdditional';

// TODO: in v9, move styled() from ComboboxAdditional.jsx to here
export var StyledComboboxAdditional = ComboboxAdditional;